/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { VariantAttributeEdit } from './variantAttributeEdit';
import { VariantAttributeOptionEdit } from './variantAttributeOptionEdit';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { FaGripLines } from 'react-icons/fa';

import utils from 'utils';

export function VariantAttributes({ form, data, variantAttrs, setVariantAttrs }) {
  const [openNewAttributeBox, setOpenNewAttributeBox] = React.useState(false);
  const [editingAttrId, setEditingAttrId] = React.useState(null);
  const [addingOptionId, setAddingOptionId] = React.useState(null);
  const [editingOptionId, setEditingOptionId] = React.useState(null);
  const s = getListStyle();



  //#region variant attributes
  function onAttributeUpdated(attr) {
    const found = utils.array.find(variantAttrs, x => x.id === attr.id)
    if (found) {
      found.name = attr.name
      found.displayName = attr.displayName
      found.required = attr.require
      //found.options = [...(attr.options || [])]
      setVariantAttrs([...variantAttrs]);
    } else {
      variantAttrs.push(attr)
      setVariantAttrs([...variantAttrs]);
    }
  }

  function onAttributeRemoved(attr) {
    const foundInx = utils.array.findIndex(variantAttrs, x => x.id === attr.id)
    if (foundInx >= 0) {
      utils.array.removeItem(variantAttrs, foundInx)
      setVariantAttrs([...variantAttrs]);
    }
  }
  
  function onAttributeOrderChanged(srcInx, desInx) {
    utils.array.moveItem(variantAttrs, srcInx, desInx);
    setVariantAttrs([...variantAttrs]);
  }

  function onAttributeOptionUpdated(attr, opt) {
    const found = utils.array.find(variantAttrs, x => x.id === attr.id)
    if (found) {
      const optFound = utils.array.find(found.options, x => x.id === opt.id)
      if (optFound) {
        optFound.value = opt.value
        optFound.displayName = opt.displayName
      } else {
        found.options.push(opt)
      }
      setVariantAttrs([...variantAttrs]);
    }
  }

  function onAttributeOptionRemoved(attr, opt) {
    const found = utils.array.find(variantAttrs, x => x.id === attr.id)
    if (found) {
      const optFoundInx = utils.array.findIndex(found.options, x => x.id === opt.id)
      if (optFoundInx >= 0) {
        utils.array.removeItem(found.options, optFoundInx)
        setVariantAttrs([...variantAttrs]);
      }
    }
  }

  function onAttributeOptionOrderChanged(attr, srcInx, desInx) {
    const found = utils.array.find(variantAttrs, x => x.id === attr.id)
    if (found) {
      utils.array.moveItem(found.options, srcInx, desInx);
      setVariantAttrs([...variantAttrs]);
    }
    
  }
  //#endregion  

  function onDragEnd(attr, result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    onAttributeOptionOrderChanged(attr, result.source.index, result.destination.index)
  }
  function onDragEndAttr(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    onAttributeOrderChanged(result.source.index, result.destination.index)
  }


  return <div>

    <DragDropContext onDragEnd={(result) => onDragEndAttr(result)}>
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className={`edit ${snapshot.isDraggingOver ? 'edit--dragging' : ''}`}
          // style={getListStyle(snapshot.isDraggingOver)}
          >
            {variantAttrs.map((attr, index) =>

              <Draggable key={attr.id} draggableId={attr.id} index={index}>
                {(provided, snapshot) => (
                  <div
                    css={s.attr}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    style={provided.draggableProps.style}
                    className={`edit ${snapshot.isDragging ? 'edit--dragging' : ''}`}
                  >

                    <div css={s.attrTitle}>
                      <div style={{ float: 'right' }}>
                        <span css={s.attrAction} onClick={() => { setAddingOptionId(attr.id) }}>add</span>
                        <span css={s.attrAction} onClick={() => { setEditingAttrId(attr.id) }}>edit</span>
                        <span css={s.attrAction} onClick={() => { setEditingAttrId(null); onAttributeRemoved(attr); }}>remove</span>
                      </div>
                      <div css={s.handle} {...provided.dragHandleProps}><FaGripLines title="Change order" /></div>
                      <b>{attr.name}</b> <i>{attr.displayName}</i></div>
                    {editingAttrId === attr.id && <VariantAttributeEdit attr={attr}
                      onSave={(attr) => { setEditingAttrId(null); onAttributeUpdated(attr); }}
                      onCancel={() => { setEditingAttrId(null) }} />}
                    <div css={s.attrOptionList}>
                      {attr.options && attr.options.length > 0 ? <div>
                        <DragDropContext onDragEnd={(result) => onDragEnd(attr, result)}>
                          <Droppable droppableId="droppable" direction="horizontal">
                            {(provided, snapshot) => (
                              <div css={s.attrOptionListItem}
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                className={`edit ${snapshot.isDraggingOver ? 'edit--dragging' : ''}`}
                              // style={getListStyle(snapshot.isDraggingOver)}
                              >
                                {attr.options.map((opt, index) => (
                                  <Draggable key={opt.id} draggableId={opt.id} index={index}>
                                    {(provided, snapshot) => (
                                      <div
                                        css={s.attrOption}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={provided.draggableProps.style}
                                        className={`edit ${snapshot.isDragging ? 'edit--dragging' : ''}`}
                                      >

                                        <b>{opt.value}</b> <i>{opt.displayName}</i>
                                        <span css={s.attrOptionAction} onClick={() => { setEditingOptionId(opt.id) }}>edit</span>
                                        <span css={s.attrOptionAction} onClick={() => { setEditingOptionId(null); onAttributeOptionRemoved(attr, opt); }}>remove</span>
                                        {editingOptionId === opt.id && <VariantAttributeOptionEdit attr={attr} attrOpt={opt}
                                          onSave={(opt) => { setEditingOptionId(null); onAttributeOptionUpdated(attr, opt); }}
                                          onCancel={() => { setEditingOptionId(null) }} />}
                                      </div>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>
                      </div> : <div css={s.err}>No options yet. Please add.</div>}

                      <div css={s.actions}>
                        {/* <span css={s.action} onClick={() => { setAddingOptionId(attr.id) }}>Add new option</span> */}
                        {addingOptionId === attr.id && <VariantAttributeOptionEdit attr={attr}
                          onSave={(opt) => { setAddingOptionId(null); onAttributeOptionUpdated(attr, opt); }}
                          onCancel={() => { setAddingOptionId(null) }} />}
                      </div>
                    </div>
                  </div>
                )}
              </Draggable>    
            )}

            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>


    <div>
      <input type="button" className="btn btn-outline-primary btn-sm" value="New Variant Attribute" onClick={() => { setOpenNewAttributeBox(!openNewAttributeBox) }} />
    </div>
    {openNewAttributeBox && <VariantAttributeEdit
      onSave={(attr) => { setOpenNewAttributeBox(false); onAttributeUpdated(attr); }}
      onCancel={() => { setOpenNewAttributeBox(false) }} />}
  </div>
}

function getListStyle() {
  var buttonSmall = {
    display: 'inline-block',
    color: 'white',
    fontSize: '60%',
    padding: '3px 10px',
    background: '#aaa',
    borderRadius: '10px',
    textTransform: 'lowercase',
    cursor: 'pointer',
    margin: '0 0 2px 5px',
    verticalAlign: 'middle',
    transition: 'all 0.3s',
    '&:hover': {
      background: '#666'
    }
  }

  return {
    attr: {
      border: 'solid 1px #ccc',
      marginBottom: '10px'
    },
    attrTitle: {
      background: '#444',
      color: '#fff',
      padding: '2px 10px'
    },
    attrAction: [buttonSmall, { background: '#777' }],
    attrOptionList: {
      background: '#eee',
      padding: '10px',
    },
    attrOptionListItem: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: '10px 0',
    },
    attrOption: {
      padding: '3px 10px',
      margin: '3px',
      border: 'solid 1px #222',
      borderRadius: '5px',
    },
    attrOptionAction: buttonSmall,
    action: {
      color: 'white',
      fontSize: '80%',
      padding: '3px 10px',
      background: '#4397ec',
      borderRadius: '10px',
      textTransform: 'uppercase',
      cursor: 'pointer',
    },
    err: {
      color: 'chocolate',
      fontSize: '70%'
    },
    handle: {
      display: 'inline-block',
      marginRight: '10px'
    }
  }
}